import { ThemeIcon } from '@mantine/core';

import DefaultLogo from '@/assets/Cercle vert.svg?react';
import { useGetDirectusProjectLogo } from '@/shared/directus/directus-hook';
import { useNavigate } from 'react-router-dom';

const HeaderLogo = () => {
  const navigate = useNavigate();

  const logoSrc = useGetDirectusProjectLogo();

  const gotToHome = () => {
    navigate('/');
  };

  return (
    <ThemeIcon
      variant="transparent"
      size={50}
      radius="xl"
      onClick={gotToHome}
      style={{
        cursor: 'pointer',
      }}
    >
      {logoSrc ? <img src={logoSrc} /> : <DefaultLogo />}
    </ThemeIcon>
  );
};

export default HeaderLogo;
